import {
  Component,
  ViewEncapsulation,
  ElementRef,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { BookingComponentVm } from 'app/Models/BookingComponent';
import { EngagementActivityVm } from 'app/Models/EngagementActivity';
import { ScheduledViewService } from '../scheduledView.service';
import { UserVM } from 'app/Models/UserVM';

@Component({
  selector: 'notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotesDialog implements OnInit {
  @Input() isNotes: boolean = false;
  @Input() noteAvailableFor: any;
  @Input() selectedInstanceId: number;
  @Input() selectedJobId: number;

  @Output() onDialogClose = new EventEmitter<any | boolean>();

  private element: any;
  date: any;
  selectedJobAssignment = 1;
  jobAssignmentList: any = [];
  showSearchListBookingComponent: boolean = false;
  engagementComponentList: any = [];
  EngagementComponent: FormControl = new FormControl();
  showSearchBCList: boolean = false;
  selectedEngagementBooking: any = {};
  selectedEngagementOld: number = 0;
  instanceIdOld: number = 0;
  showSearchBCLoader: boolean = false;
  extendData: string;
  minDate = new Date();
  loggedInUser: UserVM;
  formGroup = this.formBuilder.group({
    EngagementComponent: new FormControl('', []),
    NotesData: new FormControl('', []),
    ExtendSelection: new FormControl('extend_upto', []),
  });
  constructor(
    private el: ElementRef,
    private spinner: NgxSpinnerService,
    public scheduleViewService: ScheduledViewService,
    private formBuilder: FormBuilder
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    this.selectedEngagementBooking = {};
    this.selectedJobAssignment = 0;
    this.loggedInUser = JSON.parse(sessionStorage.getItem('resource'));
    this.formGroup
      .get('NotesData')
      .setValue(
        this.noteAvailableFor?.cellData.Description
          ? this.noteAvailableFor.cellData.Description
          : ''
      );
  }

  getEngagementActivity() {
    const param = new EngagementActivityVm();
    param.EngagementID = this.selectedJobId;
    param.InstanceId = this.selectedInstanceId;
    if (
      this.selectedJobId !== this.selectedEngagementOld ||
      this.selectedInstanceId !== this.instanceIdOld
    ) {
      this.spinner.show();
      this.selectedEngagementOld = this.selectedJobId;
      this.instanceIdOld = this.selectedInstanceId;
      this.scheduleViewService.getEngagementActivity(param).subscribe(
        (data) => {
          this.jobAssignmentList = data;
          this.setSelectedEngagementActivity(data);
        },
        (err) => {
          console.log('Error in fetching Engagement Activity', err);
          alert('Error in fetching Engagement Activity, please try again');
        },
        () => {
          this.spinner.hide();
        }
      );
    } else {
      this.setSelectedEngagementActivity(this.jobAssignmentList);
    }
  }

  setSelectedEngagementActivity = (data) => {
    if (this.noteAvailableFor?.cellData?.JobAssignmentDescr) {
      this.selectedJobAssignment = data.find(
        (item) =>
          item.EngagementActivityDescr ===
          this.noteAvailableFor.cellData.JobAssignmentDescr
      ).EngagementActivityID;
    } else {
      this.selectedJobAssignment = 0;
    }
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isNotes && changes.isNotes.currentValue === true) {
      this.selectedJobAssignment = 0;
      this.getEngagementActivity(); // Get Engagement activity data based on selected engagement.
      this.formGroup.get('ExtendSelection').setValue('extend_upto');
      this.date = null;
      this.formGroup
        .get('EngagementComponent')
        .setValue(
          changes.noteAvailableFor.currentValue.cellData.ComponentDescr
        );
      this.formGroup
        .get('NotesData')
        .setValue(changes.noteAvailableFor.currentValue.cellData.Description);
    }
  }

  getNotesPosition() {
    this.minDate = new Date(this.noteAvailableFor?.cellData.WeekStartDate);
    this.minDate.setMinutes(
      this.minDate.getMinutes() - this.minDate.getTimezoneOffset()
    );
    const notes = document.getElementById('notesWrapper');
    let styles = {
      left: this.noteAvailableFor.position.x - notes.clientWidth - 20 + 'px',
      top: this.noteAvailableFor.position.y - 55 + 'px',
    };
    return styles;
  }

  notesCancel() {
    this.onDialogClose.emit(false);
  }

  notesSubmit() {
    const params = {
      date:
        this.date === undefined
          ? new FormControl(
              new Date(this.noteAvailableFor.cellData.WeekStartDate)
            )
          : this.date,
      // radioSelection: this.extendData,
      radioSelection: this.formGroup.controls['ExtendSelection'].value,
      notes: this.formGroup.controls['NotesData'].value,
      ComponentDescr: this.formGroup.controls['EngagementComponent'].value,
      JobAssignmentDescr:
        this.jobAssignmentList?.find(
          (item) => item.EngagementActivityID === this.selectedJobAssignment
        )?.EngagementActivityDescr || null,
    };
    this.onDialogClose.emit(params);
  }

  clearDate() {
    this.date = '';
  }

  updateDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.date = new FormControl(new Date(event.value));
    this.formGroup.get('ExtendSelection').setValue('extend_upto');
  }

  updateRadioSelection(event) {}

  checkIfNewBooking() {
    return this.noteAvailableFor.cellData.CellAction === 'Create'
      ? false
      : true;
  }

  onJobAssignmentChange(event) {
    this.selectedJobAssignment = event.value;
  }

  isValidInput(fieldName): boolean {
    return (
      this.formGroup.controls[fieldName].invalid &&
      (this.formGroup.controls[fieldName].dirty ||
        this.formGroup.controls[fieldName].touched)
    );
  }

  searchBookingComponentData() {
    this.engagementComponentList = [];
    this.showSearchListBookingComponent = false;
    const bkVAlue = this.formGroup.controls['EngagementComponent'].value;
    if (bkVAlue != null && bkVAlue.trim().length >= 2) {
      this.showSearchBCLoader = true;
      const param = new BookingComponentVm();
      param.SearchKey = bkVAlue;
      param.InstanceId = this.selectedInstanceId;
      this.showSearchBCList = true;
      this.scheduleViewService.getBookingComponent(param).subscribe(
        (data) => {
          this.engagementComponentList = data;
        },
        (error) => {
          console.log(error);
        },
        () => {
          this.showSearchBCLoader = false;
        }
      );
    }
  }

  OnEngagementBookingSelect(event, item) {
    event.stopPropagation();
    this.selectedEngagementBooking = item;
    this.formGroup.controls['EngagementComponent'].patchValue(
      item?.ComponentDescr
    );
    this.showSearchBCList = false;
  }

  resetBookingComponent() {
    this.showSearchBCList = false;
    this.showSearchBCLoader = false;
    this.formGroup.controls['EngagementComponent'].patchValue('');
  }
}
